import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useWalletStore } from '@/stores'
import {
  AccountToken,
  type Account,
  type BaseAccount,
  type Maybe,
} from '@/types'

export function useAccountQuery() {
  const router = useRouter()
  const walletStore = useWalletStore()

  const account = computed<Maybe<BaseAccount>>(() => {
    if (router.currentRoute.value.query.accountTokenId) {
      return walletStore.getAccountToken({
        accountTokenId: router.currentRoute.value.query
          .accountTokenId as string,
      })
    } else if (router.currentRoute.value.query.accountId) {
      return walletStore.getAccount({
        accountId: router.currentRoute.value.query.accountId as string,
      })
    } else {
      return undefined
    }
  })
  function isAccountToken(account: any): account is AccountToken {
    return account instanceof AccountToken
  }
  const feeAccount = computed<Maybe<Account>>(() => {
    if (isAccountToken(account.value)) {
      return account.value.account
    } else {
      return account.value as Account
    }
  })

  return {
    account,
    feeAccount,
  }
}
